import { render, staticRenderFns } from "./producer_submit_cancel.vue?vue&type=template&id=67413273&scoped=true"
import script from "./producer_submit_cancel.vue?vue&type=script&lang=js"
export * from "./producer_submit_cancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67413273",
  null
  
)

export default component.exports